import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeComponentHubiloFormFields {
  formId?: EntryFieldTypes.Symbol
  plausibleEventName?: EntryFieldTypes.Symbol
}

export type TypeComponentHubiloFormSkeleton = EntrySkeletonType<TypeComponentHubiloFormFields, 'componentHubiloForm'>
export type TypeComponentHubiloForm<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeComponentHubiloFormSkeleton,
  Modifiers,
  Locales
>

export function isTypeComponentHubiloForm<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeComponentHubiloForm<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'componentHubiloForm'
}
